import { DatadogClient } from './datadog'

const ddLog = DatadogClient.getInstance()

export const fireAndForget = (promise: Promise<void>) => {
  promise.then().catch((e) => {
    ddLog.error('uncaught fireAndForget exception', undefined, e)
  })
}
